import React from 'react'
import SwipeableDrawer, { SwipeableDrawerProps } from '@mui/material/SwipeableDrawer'
import styled from 'styled-components'

export const NAVBAR_HEIGHT = 63

export const CustomDrawer = styled((props: SwipeableDrawerProps) => (
  <SwipeableDrawer {...props} disableEnforceFocus disableAutoFocus disableRestoreFocus />
))<{
  bg?: string
  customZIndex?: number
}>`
  &.MuiDrawer-modal {
    top: ${NAVBAR_HEIGHT}px;
  }
  .MuiBackdrop-root {
    top: ${NAVBAR_HEIGHT}px;
  }
  .MuiDrawer-root {
    z-index: 1199 !important;
  }
  .MuiPaper-root {
    background-color: ${({ theme, bg }) => bg || theme.colors.background};
    width: 100%;
    top: ${NAVBAR_HEIGHT}px;
    box-shadow: none;
    height: calc(100% - ${NAVBAR_HEIGHT}px);
  }
  z-index: ${({ customZIndex, theme }) => customZIndex || theme.zIndices.defaultDrawer} !important;
`
